import Skeleton from "../../Skeleton";

const AddressFormLoading = () => {
  return (
    <div className="flex gap-6">
      <div className="w-1/2 flex flex-col gap-4">
        <Skeleton className="bg-white-100" height={54} />

        <div className="flex gap-2">
          <Skeleton height={54} className="w-3/4 bg-white-100" />

          <Skeleton height={54} className="w-1/4 bg-white-100" />
        </div>

        <Skeleton className="bg-white-100" height={54} />

        <Skeleton className="bg-white-100" height={54} />

        <Skeleton className="bg-white-100" height={54} />

        <Skeleton className="bg-white-100" height={128} />
      </div>

      <div className="w-1/2">
        <Skeleton height={400} />
      </div>
    </div>
  );
};

export default AddressFormLoading;
